import apiClient from '../apiClient';
import { POST_TOUR_GUIDE_URL } from '../apiUrl';

const postTourGuideApi = data => {
  return apiClient.post(POST_TOUR_GUIDE_URL, data);
};

export default postTourGuideApi;
